<template>
  <el-dialog
    title="调拨单审单"
    :visible.sync="visible"
    width="840px"
    append-to-body=""
    @closed="handleClosed">
    <el-form
      ref="ruleForm"
      :validate-on-rule-change="false"
      :rules="rules"
      label-width="100px"
      :model="orderInfo">
      <el-form-item label="调拨单号:">{{ orderInfo.code }}</el-form-item>
      <el-form-item label="调出仓库:">{{ orderInfo.sourceWarehouseNo | warehouseName() }}</el-form-item>
      <el-form-item label="调入仓库:">{{ orderInfo.destWarehouseNo | warehouseName() }}</el-form-item>
      <el-form-item
        label="物流方式:"
        prop="transType">
        <el-radio-group v-model="orderInfo.transType">
          <el-radio-button :label="1">陆运</el-radio-button>
          <el-radio-button :label="2">空运</el-radio-button>
          <el-radio-button :label="3">自提</el-radio-button>
        </el-radio-group>
      </el-form-item>
      <template v-if="orderInfo.transType !== 3">
        <el-form-item
          label="物流模板:"
          prop="expressCode">
          <ent-logistics-select
            ref="logistics"
            v-model="orderInfo.expressCode"
            :callback="logisticsSelectCallback"
            :option="{vendorId: userInfo.orgId}" />
        </el-form-item>
        <el-form-item>
          <div slot="label">
            <el-tooltip
              effect="dark"
              content="根据物流模板信息获取">
              <i class="el-icon-question"></i>
            </el-tooltip>
            <span>发件人:</span>
          </div>
          {{ orderInfo.senderName }}-{{ orderInfo.senderMobile }}-{{ orderInfo.senderProvince }}{{ orderInfo.senderCity }}{{ orderInfo.senderDistrict }}{{ orderInfo.senderAddress }}
        </el-form-item>
      </template>
      <el-form-item
        label="收件人姓名:"
        prop="receiverName">
        <el-input v-model="orderInfo.receiverName"></el-input>
      </el-form-item>
      <el-form-item
        label="收件人手机:"
        prop="receiverMobile">
        <el-input v-model="orderInfo.receiverMobile"></el-input>
      </el-form-item>
      <el-form-item
        label="收件人电话:"
        prop="receiverTel">
        <el-input v-model="orderInfo.receiverTel"></el-input>
      </el-form-item>
      <el-form-item
        :required="orderInfo.transType !== 3"
        style="margin-bottom:0"
        label="收件省市区:">
        <el-row :gutter="0">
          <el-col :span="7">
            <el-form-item
              label-width="0"
              prop="receiverProvince">
              <el-input v-model="orderInfo.receiverProvince"></el-input>
            </el-form-item>
          </el-col>
          <el-col
            :span="7"
            :offset="1">
            <el-form-item
              label-width="0"
              prop="receiverCity">
              <el-input v-model="orderInfo.receiverCity"></el-input>
            </el-form-item>
          </el-col>
          <el-col
            :span="7"
            :offset="1">
            <el-form-item
              label-width="0"
              prop="receiverDistrict">
              <el-input v-model="orderInfo.receiverDistrict"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form-item>
      <el-form-item
        label="收件地址:"
        prop="receiverAddress">
        <el-input v-model="orderInfo.receiverAddress"></el-input>
      </el-form-item>
      <el-form-item
        label="备注:"
        prop="remark">
        <el-input
          v-model="orderInfo.remark"
          type="textarea"
          autosize></el-input>
      </el-form-item>
      <el-form-item
        label="调拨明细:"
        prop="detailList">
        <el-table
          v-loading="loading"
          max-height="400px"
          :data="orderInfo.detailList"
          border>
          <el-table-column
            :resizable="false"
            label="商品名称"
            prop="skuName">
            <template slot-scope="{row}">
              {{ row.skuName || row.productName }}
            </template>
          </el-table-column>
          <el-table-column
            :resizable="false"
            label="商品编码"
            width="100"
            prop="skuCode"></el-table-column>
          <el-table-column
            :resizable="false"
            label="调拨数量"
            width="100"
            prop="num">
            <template slot-scope="{row}">
              {{ row.num }}{{ row.measureUnit | measureUnitName() }}
            </template>
          </el-table-column>
        </el-table>
      </el-form-item>
    </el-form>
    <div slot="footer">
      <el-button @click="toggleModal(false)">取 消</el-button>
      <el-button
        :loading="loading"
        type="primary"
        @click="add">确 定</el-button>
    </div>
  </el-dialog>
</template>
<script>
import EntLogisticsSelect from '../../../components/business/ent-logistics-select.vue'
import { mapState } from 'vuex'
// import VendorTagSelect from '../../../components/business/vendor-tag-select.vue'
export default {
  name: 'AllocateAuditModal',
  components: { EntLogisticsSelect },
  props: {
    callback: Function
  },
  data() {
    return {
      loading: false,
      allocateOrderId: null,
      orderInfo: {
        expressCode: null,
        transType: 1,
        receiverName: null,
        receiverMobile: null,
        receiverTel: null,
        receiverProvince: null,
        receiverCity: null,
        receiverDistrict: null,
        receiverAddress: null
      },
      visible: false
    }
  },
  computed: {
    ...mapState({
      userInfo: state => state.account.userInfo
    }),
    rules() {
      const { receiverMobile, receiverTel, transType } = this.orderInfo
      return {
        expressCode: [{ required: true, message: '请选择物流公司', trigger: 'change' }],
        transType: [{ required: true, message: '请选择发货方式', trigger: 'change' }],
        receiverName: [{ required: true, message: '请输入收件人姓名', trigger: 'blur' }],
        receiverMobile: [{ required: transType !== 3 && (!receiverMobile && !receiverTel), message: '收件人手机/电话至少填写一个', trigger: 'blur' }],
        receiverTel: [{ required: transType !== 3 && (!receiverMobile && !receiverTel), message: '收件人手机/电话至少填写一个', trigger: 'blur' }],
        receiverProvince: [{ required: transType !== 3, message: '请输入收件省份', trigger: 'blur' }],
        receiverCity: [{ required: transType !== 3, message: '请输入收件城市', trigger: 'blur' }],
        receiverDistrict: [{ required: transType !== 3, message: '请输入收件区县', trigger: 'blur' }],
        receiverAddress: [{ required: transType !== 3, message: '请输入收件地址', trigger: 'blur' }]
      }
    }
  },
  methods: {
    toggleModal(visible) {
      this.visible = visible
    },
    handleClosed() {
      this.orderInfo = {
        expressCode: null,
        transType: 1,
        receiverName: null,
        receiverMobile: null,
        receiverTel: null,
        receiverProvince: null,
        receiverCity: null,
        receiverDistrict: null,
        receiverAddress: null
      }
      this.allocateOrderId = null
      setTimeout(() => {
        this.$refs.ruleForm.clearValidate()
      }, 20)
    },
    logisticsSelectCallback(row) {
      this.orderInfo.senderName = row.senderName
      this.orderInfo.senderProvince = row.senderProvinceName
      this.orderInfo.senderCity = row.senderCityName
      this.orderInfo.senderDistrict = row.senderAreaName
      this.orderInfo.senderAddress = row.senderAddress
      this.orderInfo.senderMobile = row.senderPhone
    },
    add() {
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          this.loading = true
          const { id: allocateOrderId, expressCode = '00', transType, remark, receiverName, receiverMobile, receiverTel, receiverProvince, receiverCity, receiverDistrict, receiverAddress } = this.orderInfo
          this.$store.dispatch('outstock/allocateaudit', {
            payload: {
              allocateOrderId, expressCode: expressCode || 0, transType, remark, receiverName, receiverMobile, receiverTel, receiverProvince, receiverCity, receiverDistrict, receiverAddress
            },
            success: () => {
              this.loading = false
              this.toggleModal(false)
              this.callback && this.callback()
            },
            fail: () => {
              this.loading = false
            }
          })
        }
      })
    },
    fetchList(cb) {
      this.loading = true
      this.$store.dispatch('outstock/allocatedetail', {
        payload: {
          allocateOrderId: this.allocateOrderId
        },
        success: res => {
          this.loading = false
          this.orderInfo = {
            ...res.data.data,
            expressCode: res.data.data.expressCode ? +res.data.data.expressCode : null,
            transType: res.data.data.transType || 1
            // orderFlag: res.data.data.orderFlag === '' ? null : +res.data.data.orderFlag
          }
          cb && cb()
        },
        fail: () => {
          this.loading = false
        }
      })
    },
    fetch(row) {
      this.allocateOrderId = row.id
      this.fetchList(() => {
        this.toggleModal(true)
      })
    }
  }
}
</script>
